export const ROUTES_COMMON = {
    newcust: 'newcust',
    sendFPTIData: 'sendFPTIData',
    session: 'session',
    clearSession: 'clearSession',
    close: 'ppcclose',
    lander: 'lander'
};
